<template>
  <div class="cascader-select">
    <el-select
      v-model="selectModel[column.prop]"
      v-for="column in column.casaderOptions"
      :key="column.prop" :disabled="column.disabled"
      placeholder="请选择"
      @change="selectChange(column,true)"
    >
      <el-option
        v-for="item in column.data"
        :key="item.value||item.id"
        :label="item.label||item.name"
        :title="item.label||item.name"
        :value="item.value||item.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
  import qs from 'qs'

  export default {
    props: {
      formModel: {
        type: Object,
        default: () => {
          return {};
        }
      },
      column: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data () {
      return {
        selectModel: {}
      };
    },
    created () {
      this.column.casaderOptions.map(item => {
        this.$set(this.selectModel, item.prop, this.formModel[item.prop] || '');
        if (item.prop == this.column.prop && item.url) {
          this.getSelectData(item);
          if (this.formModel[item.prop]) {
            this.selectChange(item);
          }
        }
      });
    },
    methods: {
      //所有子组件必有此方法为当前数据赋值
      setValue () {
        let formModel = this.$store.state[this.$utils.storeKeys.CURRENTFORM];
        this.column.casaderOptions.map(item => {
          if (this.formModel[item.prop]) {
            this.$set(this.selectModel, item.prop, this.formModel[item.prop]);
            this.selectChange(item);
          }
        });
      },
      //为formModel赋值
      getValue () {
        let keys = Object.keys(this.selectModel);
        keys.map(key => {
          this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
            key: key,
            value: this.selectModel[key]
          });
        });
      },
      clearData () {
        let keys = Object.keys(this.selectModel);
        keys.map(key => {
          this.selectModel[key] = '';
          this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
            key: key,
            value: ''
          });
        })
      },
      // 下拉框联动
      selectChange (column, parentChange) {
        if (column.childProps) {
          // 根据当前选项获取子集
          // 联动字段选项赋值
          let childColumn = this.column.casaderOptions.filter(item => {
            return item.prop === column.childProps;
          })[0];
          if (childColumn.url) {
            childColumn.data = [];
            this.getSelectData(childColumn, {
              parentId: this.selectModel[column.prop]
            });
          } else {
            // 当前父类选择的数据
            let parentData = column.data.filter(dataItem => {
              return dataItem.value === this.selectModel[column.prop] || dataItem.id === this.selectModel[column.prop];
            });
            // 错误数据兼容
            if (parentData.length > 0) {
              childColumn.data = parentData[0].children;
            }
          }
          if (parentChange) {
            this.selectModel[childColumn.prop] = '';
          }
        }
        this.setNameFormId(column);
        if (parentChange) {
          column.change && this.$emit('cascaderChange', column, this.selectModel);
        }
      },
      setNameFormId (column) {
        //id存在则name存在
        if (column.multiple || !(/[\w]Id$/).test(column.prop) || !column.data || column.data.length == 0) return;
        if (this.formModel[column.prop]) {
          this.formModel[column.prop.replace(/(.*)Id/, '$1Name')] = '';
        }
        let currentItem = column.data.filter(item => {
          return item.id == this.formModel[column.prop]
        });
        if (currentItem.length > 0) {
          this.formModel[column.prop.replace(/(.*)Id/, '$1Name')] = currentItem[0].name;
        }
      },
      // 获取各种下拉菜单信息
      getSelectData (column, param = {}) {
        Object.assign(param || {}, column.param || {});
        this.$axios
          .fetchPost(column.url, qs.stringify(param), {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'})
          .then(data => {
            if (data.code == 200) {
              this.$set(column, 'data', data.data);
              if (column.defaultIndex != undefined) {
                this.selectModel[column.prop] =
                  column.data[column.defaultIndex].value;
              }
              if (this.selectModel[column.prop]) {
                this.selectChange(column);
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getFormData () {
        return this.selectModel;
      }
    }
  };
</script>
<style>
  .cascader-select .el-select {
    margin-right: 10px;
  }

  .cascader-select .el-select, .cascader-select .el-select .el-input {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/cascaderSelect.vue